import * as React from 'react'
import { connect } from 'react-redux'
import { ContactImportComponent } from './ContactImport'
import { reduxForm } from 'redux-form'
import { flow } from 'lodash'
import { push } from 'react-router-redux'
import { importContacts } from '../Contacts.actions'

const formName = 'contactImport'

export interface IContactImportContainerProps {
  onAfterSubmit: () => undefined
}

const stateToProps = () => ({})

export const dispatchToProps = {
  push,
  importContacts,
}

export const ContactImport = flow<any, any, React.SFC<IContactImportContainerProps>>(
  reduxForm({ form: formName }),
  connect(stateToProps, dispatchToProps)
)(ContactImportComponent)



// WEBPACK FOOTER //
// src/features/Contacts/ContactImport/ContactImport.container.ts